var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPesq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pesq") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-1501.000000, -36.000000)",
    stroke: "",
    strokeWidth: 2.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(1489.000000, 37.652174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8042196,20.0948903 C33.3541627,20.0948903 37.8532806,15.5964958 37.8532806,10.0474452 C37.8532806,4.49839449 33.3541627,0 27.8042196,0 C22.2542765,0 17.7551585,4.49839449 17.7551585,10.0474452 C17.7551585,15.5964958 22.2542765,20.0948903 27.8042196,20.0948903 Z M13.8532806,24 L17.7551585,20.0948903",
    id: "pesq"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesq);
export default __webpack_public_path__ + "static/media/pesq.f57efda8fda828ae36a54997c36a7648.svg";
export { ForwardRef as ReactComponent };